export default __webpack_public_path__ + "static/media/51_photo.9d94a073.jpg";